export default {
  InvoiceIsSaved: false,
  IsDraft: true,
  ProgramID: 0,
  ProgramName: '',
  ProgramCurrencyCode: 'USD',
  POid: 0,
  PONumber: '',
  POCreatedDate: null,
  SupplierId: 0,
  SupplierName: '',
  SupplierUserId: 0,
  MyVendorTempEONumber: 0,
  Supplier: {
    VendorID: 0,
    VendorUserID: 0
  },
  InvoiceDate: null,
  DueDate: null,
  PaymentTypeID: 0,
  PaymentType: '',
  CurrencyID: 0,
  CurrencyCode: '',
  CurrencyName: '',
  Attachments: [],
  User: {
    token: ''
  },
  ReferenceNo: '',
  HasRushPayment: false,
  IsSameDayDeposit: false,
  IsReimbursement: false,
  RushPaymentReason: '',
  Errors: {
    ProgramMissing: false,
    SupplierMissing: false,
    SupplierZipCodeMissing: false,
    PaymentTypeMissing: false,
    InvoiceDateMissing: false,
    DueDateMissing: false,
    InvoiceDateIncomplete: false,
    DueDateIncomplete: false,
    AttachmentsMissing: false,
    InvoiceCurrencyMissing: false,
    InvoiceAmountMissing: false,
    InvoiceAmountOutOfRange: false,
    InvoiceAmountNegative: false,
    InitialTotalAmountMissing: false,
    POMissing: false,
    ReferenceNoMissing: false,
    AllocationTypeMissing: false,
    AllocationMissing: false,
    InvoiceAmountExceededPOThreshold: false,
    isEditInit: false
  },
  HasAllocationSection: false,
  IsAllocationSelected: false,
  HasAllocationForScan: false,
  InvoiceAmount: '',
  VATGSTAmount: '',
  InvoiceWorkflow: '',
  UseSavingsFields: false,
  InitialTotalAmount: 0,
  CreatedByInfo: {
    Name: '',
    Email: '',
    Phone: ''
  },
  DiscountPaymentTermID: 0,
  DiscountName: '',
  ApproveNote: ''
}



// WEBPACK FOOTER //
// ./src/components/_modules/I2P/models/invoice-information-model.js